import StudioA from './StudioA';

export default StudioA;
